module.exports = __webpack_public_path__ + "static/media/diners.f0f808e1.svg";